import React, { useState, useRef } from 'react';
import { translate } from 'react-i18next';

// import moment from 'moment';
// import Helmet from 'react-helmet';
// import DayPickerInput, { DateUtils } from 'react-day-picker';
// // import DayPickerInput from 'react-day-picker/DayPickerInput';
// import 'react-day-picker/lib/style.css';
// import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';
import Helmet from 'react-helmet';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import { formatDate, parseDate } from 'react-day-picker/moment';

import { Form } from 'common/components';

const ReportsHistoricsFilters = ({
  handleToggleSearch = () => {},
  handleExactSearch = () => {},
  columnSearch = [],
  accounts = [],
  costCenters = [],
  employees = [],
  status = [],
  handleSubmit = () => {},
  handleValueChange = () => {},
  t,
  values = {},
}) => {
  const accountsOptions = accounts.map((a) => ({ label: `${a.key} - ${a.name}`, value: a.id }));
  const costCentersOptions = costCenters.map((c) => ({
    label: `${c.key} - ${c.name}`,
    value: c.id,
  }));
  const employeesOptions = employees.map((e) => ({ label: `${e.key} - ${e.name}`, value: e.id }));
  const statusNotDeleted = []; // Error al traer un dato como undefined.
  // status.forEach(s => s ? statusNotDeleted.push(s) : null);
  // const statusOptions = statusNotDeleted.map(s => ({ label: t(s.value), value: s.key }));
  const statusOptions = [
    { label: 'Pendiente', value: 'PENDING' },
    { label: 'Aceptado', value: 'ACCEPTED' },
    { label: 'Rechazado', value: 'REJECTED' },
  ];

  const [fromCreatedAt, setFromCreatedAt] = useState(0);
  const [toCreatedAt, setToCreatedAt] = useState(0);
  const modifiersCreatedAt = { start: fromCreatedAt, end: toCreatedAt };
  let inputElCreatedAt = null;

  const showFromMonth = () => {
    if (!fromCreatedAt) {
      return;
    }
    if (moment(toCreatedAt).diff(moment(fromCreatedAt), 'months') < 2) {
      inputElCreatedAt.daypicker.showMonth(fromCreatedAt);
    }
  };

  const handleCreatedAtStart = (fromChanged) => {
    setFromCreatedAt(fromChanged); // Save value from
    inputElCreatedAt.input.focus(); // Change focus to from
  };

  const handleCreatedAtEnd = (toChanged) => {
    setToCreatedAt(toChanged);
    showFromMonth();
    if (fromCreatedAt !== undefined) {
      handleValueChange({ target: { value: fromCreatedAt, name: 'createdAtStart' } });
      handleValueChange({ target: { value: toChanged, name: 'createdAtEnd' } });
    }
  };

  const handleResetClick = (e) => {
    // e.preventDefault();
    setFromCreatedAt(0);
    setToCreatedAt(0);
    handleValueChange({ target: { value: '', name: 'createdAtStart' } });
    handleValueChange({ target: { value: '', name: 'createdAtEnd' } });
  };

  const [fromReviewDate, setFromReviewDate] = useState(0);
  const [toReviewDate, setToReviewDate] = useState(0);
  const modifiersReviewDate = { start: fromReviewDate, end: toReviewDate };
  let inputElReviewDate = null;

  const showFromMonthReviewDate = () => {
    if (!fromReviewDate) {
      return;
    }
    if (moment(toReviewDate).diff(moment(fromReviewDate), 'months') < 2) {
      inputElReviewDate.daypicker.showMonth(fromReviewDate);
    }
  };

  const handleReviewDateStart = (fromChanged) => {
    setFromReviewDate(fromChanged); // Save value from
    inputElReviewDate.input.focus(); // Change focus to from
  };

  const handleReviewDateEnd = (toChanged) => {
    setToReviewDate(toChanged);
    showFromMonthReviewDate();
    if (fromReviewDate !== undefined) {
      handleValueChange({ target: { value: fromReviewDate, name: 'reviewDateStart' } });
      handleValueChange({ target: { value: toChanged, name: 'reviewDateEnd' } });
    }
  };

  const handleResetClickReviewDate = (e) => {
    // e.preventDefault();
    setFromReviewDate(0);
    setToReviewDate(0);
    handleValueChange({ target: { value: '', name: 'reviewDateStart' } });
    handleValueChange({ target: { value: '', name: 'reviewDateEnd' } });
  };

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row mt-3">
        <div className="col-6 col-sm-6 col-md-4 col-lg-2">
          <Form.FieldInput
            autoFocus={true}
            label={t('actions.search')}
            name={'fulltext'}
            placeholder={t('actions.search')}
            handleChange={handleValueChange}
            value={values.fulltext}
          />
        </div>
        {/* ColumnSearch */}
        <div className="col-6 col-sm-6 col-md-4 col-lg-2 pt-4 mt-1">
          <div className="dropdown pb-4">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {t('actions.selectSearch')}
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
              style={{
                maxHeight: '300px',
                overflowY: 'scroll',
              }}
            >
              <div className="dropdown-item form-check form-check-inline">
                {/* <hr class="solid"></hr> */}
                <label className="form-check-label">{t('actions.selectedSearch')}</label>
              </div>
              {columnSearch.map((column) => {
                if (column.separator) {
                  return (
                    <div>
                      <hr class="solid"></hr>
                      <div className="dropdown-item form-check form-check-inline">
                        <label className="form-check-label">{column.separator}</label>
                      </div>
                    </div>
                  );
                } else
                  return (
                    <div className="dropdown-item form-check form-check-inline">
                      <input
                        type="checkbox"
                        checked={column.search}
                        class="form-check-input"
                        onClick={(e) => {
                          handleToggleSearch(column.key);
                        }}
                      />
                      <label
                        className="form-check-label"
                        onClick={(e) => {
                          e && e.preventDefault();
                          handleToggleSearch(column.key);
                        }}
                      >
                        {column.name}
                      </label>
                    </div>
                  );
              })}
              <hr class="solid"></hr>
              <div className="dropdown-item form-check form-check-inline">
                <label className="form-check-label">{t('actions.optionsSearch')}</label>
              </div>

              <div className="dropdown-item form-check form-check-inline">
                <input
                  type="checkbox"
                  checked={values.exactSearch}
                  class="form-check-input"
                  onClick={(e) => {
                    handleExactSearch();
                  }}
                />
                <label
                  className="form-check-label"
                  onClick={(e) => {
                    e && e.preventDefault();
                    handleExactSearch();
                  }}
                >
                  {t('actions.exactSearch')}
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* ColumnSearch */}
        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={accountsOptions}
            autoFocus={true}
            label={t("reports.fields.accounts")}
            name={"accounts"}
            placeholder={t("reports.fields.accounts")}
            handleChange={handleValueChange}
            value={values.accounts}
          />
        </div> */}
        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={costCentersOptions}
            autoFocus={true}
            label={t("reports.fields.costCenters")}
            name={"costCenters"}
            placeholder={t("reports.fields.costCenters")}
            handleChange={handleValueChange}
            value={values.costCenters}
          />
        </div> */}
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={employeesOptions}
            autoFocus={true}
            label={t('reports.fields.employees')}
            name={'employees'}
            placeholder={t('reports.fields.employees')}
            handleChange={handleValueChange}
            value={values.employees}
          />
        </div>

        {/* TODO: Add status out */}
        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={statusOptions}
            autoFocus={true}
            label={t("reports.fields.status")}
            name={"statusHistoric"}
            placeholder={t("reports.fields.status")}
            handleChange={handleValueChange}
            value={values.statusHistoric}
          />
        </div> */}

        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldSelect
            label={t("reports.fields.depreciationType")}
            name={"depreciationType"}
            noEmptyOption={true}
            handleChange={handleValueChange}
            value={values.depreciationType}
          >
            <option value="fiscal">{t("reports.values.depreciationType.fiscal")}</option>
            <option value="financial">{t("reports.values.depreciationType.financial")}</option>
          </Form.FieldSelect>
        </div> */}

        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            label={t("reports.fields.createdAt")}
            name={"createdAt"}
            placeholder={t("reports.fields.createdAt")}
            handleChange={handleValueChange}
            value={values.createdAt}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            label={t("reports.fields.reviewDate")}
            name={"reviewDate"}
            placeholder={t("reports.fields.reviewDate")}
            handleChange={handleValueChange}
            value={values.reviewDate}
          />
        </div> */}

        <div className="col-sm-6 col-md-4">
          <p>{t('reports.fields.createdAt')}</p>
          <div className="InputFromTo">
            <DayPickerInput
              value={fromCreatedAt}
              placeholder="From"
              format="LL"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [fromCreatedAt, { from: fromCreatedAt, to: toCreatedAt }],
                disabledDays: { after: toCreatedAt },
                toMonth: toCreatedAt,
                modifiers: modifiersCreatedAt,
                numberOfMonths: 2,
              }}
              onDayChange={handleCreatedAtStart}
            />{' '}
            —{' '}
            <span className="InputFromTo-to">
              <DayPickerInput
                ref={(input) => {
                  inputElCreatedAt = input;
                }}
                value={toCreatedAt}
                placeholder="To"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                dayPickerProps={{
                  selectedDays: [fromCreatedAt, { from: fromCreatedAt, to: toCreatedAt }],
                  disabledDays: { before: fromCreatedAt },
                  modifiers: modifiersCreatedAt,
                  month: fromCreatedAt,
                  fromMonth: fromCreatedAt,
                  numberOfMonths: 2,
                }}
                onDayChange={handleCreatedAtEnd}
              />
            </span>
            <button className="link btn btn-info mt-0" onClick={handleResetClick}>
              Reset
            </button>
            <Helmet>
              <style>{`
              .InputFromTo .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .InputFromTo .DayPicker-Day {
                border-radius: 0 !important;
              }
              .InputFromTo .DayPicker-Day--start {
                border-top-left-radius: 50% !important;
                border-bottom-left-radius: 50% !important;
              }
              .InputFromTo .DayPicker-Day--end {
                border-top-right-radius: 50% !important;
                border-bottom-right-radius: 50% !important;
              }
              .InputFromTo .DayPickerInput-Overlay {
                width: 550px;
              }
              .InputFromTo-to .DayPickerInput-Overlay {
                margin-left: -198px;
              }
            `}</style>
            </Helmet>
          </div>
        </div>

        {/* <div className="col-sm-6 col-md-4">
          <p>{t("reports.fields.reviewDate")}</p>
          <div className="InputFromTo">
            <DayPickerInput
              value={fromReviewDate}
              placeholder="From"
              format="LL"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [fromReviewDate, { from: fromReviewDate, to: toReviewDate }],
                disabledDays: { after: toReviewDate },
                toMonth: toReviewDate,
                modifiers: modifiersReviewDate,
                numberOfMonths: 2,
              }}
              onDayChange={handleReviewDateStart}
            />{' '}
        —{' '}
            <span className="InputFromTo-to">
              <DayPickerInput
                ref={(input) => { inputElReviewDate = input }}
                value={toReviewDate}
                placeholder="To"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                dayPickerProps={{
                  selectedDays: [fromReviewDate, { from: fromReviewDate, to: toReviewDate }],
                  disabledDays: { before: fromReviewDate },
                  modifiers: modifiersReviewDate,
                  month: fromReviewDate,
                  fromMonth: fromReviewDate,
                  numberOfMonths: 2,
                }}
                onDayChange={handleReviewDateEnd}
              />
            </span>
            <button className="link" onClick={handleResetClickReviewDate}>
              Reset
            </button>
            <Helmet>
              <style>{`
              .InputFromTo .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .InputFromTo .DayPicker-Day {
                border-radius: 0 !important;
              }
              .InputFromTo .DayPicker-Day--start {
                border-top-left-radius: 50% !important;
                border-bottom-left-radius: 50% !important;
              }
              .InputFromTo .DayPicker-Day--end {
                border-top-right-radius: 50% !important;
                border-bottom-right-radius: 50% !important;
              }
              .InputFromTo .DayPickerInput-Overlay {
                width: 550px;
              }
              .InputFromTo-to .DayPickerInput-Overlay {
                margin-left: -198px;
              }
            `}</style>
            </Helmet>
          </div>
        </div> */}
      </div>
    </form>
  );
};

export default translate()(ReportsHistoricsFilters);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/ins_outs/InsOutsReportFilters.js